import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionsService } from '../../common/services/permissions.service';
import { SelectOption } from '../../common/components/forms/xp-select.component';

@Component({
  selector: 'role-picker',
  template: `
    <div class="role-picker">
      <xp-select
        [value]="value"
        (valueChange)="onValueChange($event)"
        class="form-control xp-select"
        [options]="roleOptions"
      >
      </xp-select>
    </div>
  `,
})
export class RolePickerComponent {
  @Input() value: string;
  @Output() onChange = new EventEmitter<string>();
  roleOptions: SelectOption[] = [];

  constructor(private permissionsService: PermissionsService) {
    this.hasPermission('changeAccountOwner').subscribe((hasPermission) => {
      this.roleOptions = [
        { value: 'admin', text: 'roles.admin', translate: true },
        { value: 'member', text: 'roles.member', translate: true },
        hasPermission ? { value: 'owner', text: 'roles.owner', translate: true } : null,
      ].filter(Boolean);
    });
  }

  onValueChange(value) {
    this.onChange.emit(value);
  }

  private hasPermission(permissionName) {
    return this.permissionsService.hasPermission(permissionName);
  }
}
